import { Stack, SvgIconProps, Typography } from "@mui/material";
import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import Resources from "src/@types/resources";
import CareIcon from "src/assets/icons/CareIcon";
import HomeFilledIcon from "src/assets/icons/HomeFilledIcon";
import HomeIcon from "src/assets/icons/HomeIcon";
import MessageFilledIcon from "src/assets/icons/MessageFilledIcon";
import MessageIcon from "src/assets/icons/MessageIcon";
import ShopIcon from "src/assets/icons/ShopIcon";
import { Paths } from "src/constants/paths";
import VaccinesOutlinedIcon from "@mui/icons-material/VaccinesOutlined";
import { usePatientSubscriptions } from "src/context/PatientSubscriptionsProvider";

type Page = {
  name: keyof Resources["translation"]["navBar"];
  link: string;
  outlined: FC<SvgIconProps>;
  filled: FC<SvgIconProps>;
};

const pages: Page[] = [
  {
    name: `home`,
    link: Paths.PATIENT_DASHBOARD,
    outlined: HomeIcon,
    filled: HomeFilledIcon,
  },
  {
    name: `messaging`,
    link: Paths.MESSAGING,
    outlined: MessageIcon,
    filled: MessageFilledIcon,
  },
  {
    name: `glp-1`,
    link: Paths.GLP1,
    outlined: VaccinesOutlinedIcon,
    filled: VaccinesOutlinedIcon,
  },
  {
    name: `care`,
    link: Paths.CARE,
    outlined: CareIcon,
    filled: CareIcon,
  },
  {
    name: `shop`,
    link: Paths.SHOP,
    outlined: ShopIcon,
    filled: ShopIcon,
  },
];

const BottomDashboardNavBar = () => {
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const page = "navBar";
  const subscriptions = usePatientSubscriptions((subs) => subs);

  const filteredPages = useMemo(() => {
    const page =
      subscriptions.length === 0 ||
      subscriptions.every((s) => s.status === "canceled")
        ? "messaging"
        : "glp-1";

    return pages.filter((p) => p.name !== page);
  }, [subscriptions]);

  return (
    <Stack
      data-testid="navbar-stack"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
      pl={4.5}
      pr={4.5}
      pt={2}
      pb={2}
    >
      {filteredPages.map((item) => {
        const { name, filled, outlined, link } = item;
        const isActive = pathname === link;
        const IconComponent = isActive ? filled : outlined;
        return (
          <Link key={name} to={link}>
            <Stack alignItems="center" gap={0.5}>
              <IconComponent
                style={{ color: isActive ? "#00B6B8" : "#6C7278" }}
              />

              <Typography variant="body2" color="#6C7278" fontWeight={500}>
                {t(`${page}.${name}`)}
              </Typography>
            </Stack>
          </Link>
        );
      })}
    </Stack>
  );
};

export default BottomDashboardNavBar;
